export const sendGoogleAnalyticsEvent = (options) => {
	window.ga('send', options);
};

export const sendPageView = (location) => {
	window.ga('set', 'page', location.pathname + location.search);
	window.ga('send', 'pageview');
};
